// extracted by mini-css-extract-plugin
module.exports = {"backButton":"WizardNavigation_backButton__5wnJL","title":"WizardNavigation_title__Suw_p"};